module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = fs
// module chunks = 5